// THỨ TỰ HAI HÀNG THỜI GIAN CỦA VIỆC — «Hạn» và «Bắt đầu» hàng nào đứng trên. Chuẩn của HỆ, cùng khuôn với dateOrder.js.
//
// Sếp Phú 03/10/2026 chốt cho cả ba hệ: «hạn phải nằm trên, bắt đầu có thể bỏ trống nên phải nằm sau» (TaskTimeFields).
// 10/10/2026 khách Site Connect (Canada, quen Connecteam — ca đọc «bắt đầu → kết thúc») muốn Bắt đầu TRÊN Hạn ⇒ Site Connect
// lật thứ tự, Work + Core giữ Hạn trên. Chỉ đổi THỨ TỰ VẼ — giá trị, khoá, luật ghi của ô thời gian y nguyên.
//
// Host khai lúc khởi động: `initI18n({ taskTimeOrder: 'start_first' })` (admin Connect). Không khai ⇒ 'due_first'.
// ⚠️ KHÔNG đọc `@host/tenant` ở đây: console của Work + Connect nạp `@cnv/ui/i18n` mà không có alias đó.

let thuTu = 'due_first';

/** 'start_first' | 'due_first' — giá trị lạ rơi về 'due_first'. */
export function setTaskTimeOrder(order) {
  thuTu = order === 'start_first' ? 'start_first' : 'due_first';
}

export function getTaskTimeOrder() {
  return thuTu;
}
